module.exports = __webpack_public_path__ + "img/awesome.ec1ded98.svg";